<div class="inventory-tabs">
  <a routerLink="/dashboard/asset-dashboard" routerLinkActive="active" [routerLinkActiveOptions]="{exact:true}" *ngIf="userPermissions.assets.indexOf('list') >= 0">
    Dashboard
  </a>
  <a routerLink="/dashboard/assets" routerLinkActive="active" [routerLinkActiveOptions]="{exact:true}" *ngIf="userPermissions.assets.indexOf('list') >= 0">
    Activos
  </a>
  <a routerLink="/dashboard/asset-locations" routerLinkActive="active" [routerLinkActiveOptions]="{exact:true}" *ngIf="userPermissions.assets.indexOf('list') >= 0">
    Ubicaciones de activo
  </a>
  <a routerLink="/dashboard/asset-requests" routerLinkActive="active" [routerLinkActiveOptions]="{exact:true}" *ngIf="userPermissions.asset_requests.indexOf('list') >= 0">
    Solicitudes
  </a>
  <a routerLink="/dashboard/asset-pickups" routerLinkActive="active" [routerLinkActiveOptions]="{exact:true}" *ngIf="userPermissions.assets.indexOf('list') >= 0">
    Recojos
  </a>
  <a routerLink="/dashboard/asset-types" routerLinkActive="active" [routerLinkActiveOptions]="{exact:true}" *ngIf="userPermissions.asset_types.indexOf('list') >= 0">
    Tipos de activo
  </a>
</div>
